import { FaCheck } from 'react-icons/fa';
import RequiredFormLabel from '../../RequiredFormLabel/RequiredFormLabel';
import { Nav } from 'react-bootstrap';
import { LeadWizardSteps } from '../../../api/models/Leads/LeadWizardSteps'
import '../../../pages/Leads/LeadsPage.scss';

const NavItem = ({ title, text, eventKey, isValid = false, mustComplete, showIsOptional = false, forceRequired = false }: {
	forceRequired?: boolean;
	showIsOptional?: boolean;
	eventKey: string;
	title: string;
	text: string;
	mustComplete?: LeadWizardSteps[];
	isValid?: boolean;
}) => {

	return (
		<Nav.Item >
			{/* lead-wizard-nav-link */}
			<Nav.Link eventKey={eventKey} className='text-start text-muted text-success'>

				{/* <Nav.Link eventKey={eventKey} className='text-start text-muted text-success text-sm lead-wizard-nav-link'> */}
				<div style={{fontSize: 16}}>
					{isValid && <span><FaCheck className='text-success'></FaCheck> &nbsp;</span>}
					<b>
						<RequiredFormLabel label={title} required={showIsOptional === true ? false : (forceRequired || mustComplete?.includes(eventKey as LeadWizardSteps))} />
					</b>
				</div>
				<div className='text-sm' style={{fontSize: 16}}>
					{text}
				</div>
			</Nav.Link>
		</Nav.Item>
	)
}


export default NavItem;
